import './App.css';
import Home from './pages/Home';
import NavBar from './layout/NavBar';
import BulkOps from './pages/BulkOps';
import BadgeStore from './pages/BadgeStore';
import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import NotFoundPage from './pages/NotFoundPage';
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { useEffect } from 'react';

const AppContent = () => {
  const location = useLocation();
  const hideNavbarPaths = ["/login","/signup"];
  const shouldHideNavbar = hideNavbarPaths.includes(location.pathname);

  // Update body class based on route
  useEffect(() => {
    document.body.className = ''; // Clear existing classes
    if (location.pathname === '/login') {
      document.body.classList.add('login');
    } else if (location.pathname === '/') {
      document.body.classList.add('home');
    } else if (location.pathname === '/bulk-operations') {
      document.body.classList.add('bulkops');
    } else if (location.pathname === '/badge-store') {
      document.body.classList.add('badgestore');
    }
    else if (location.pathname === '/signup') {
      document.body.classList.add('login');
    }
  }, [location.pathname]);

  return (
    <>
      {!shouldHideNavbar && <NavBar />}
      <div className="content-container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/bulk-operations" element={<BulkOps />} />
          <Route path="/badge-store" element={<BadgeStore />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </div>
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Router>
        <AppContent />
      </Router>
    </div>
  );
}

export default App;